import {List} from '@mui/material';
import {Link, WithIRI} from '../../types/api';
import React, {ReactNode} from 'react';
import {getBestTranslatedValue} from '../../lib/localeHelper';
import {addSourceTracker, TrackingSource} from '../../lib/tracking';
import SimpleLink from './SimpleLink.tsx';
import {PreviewProfileProps} from './types.ts';

export type LinkProp = {
    label: ReactNode;
    trackingUrl?: string | undefined;
    url?: string | undefined;
    locale?: string | undefined;
} & Omit<WithIRI<Link>, 'label' | 'url' | 'id'>;

type Props = {
    links: LinkProp[];
    locale: string | undefined;
} & PreviewProfileProps;

export default function Links({links, locale, isPreview, userLocales}: Props) {
    return (
        <List>
            {links.map((l, index) => {
                const linkLocale = l.locale || locale;

                const label = getBestTranslatedValue(
                    l.translations ?? {},
                    'label',
                    l.label,
                    linkLocale,
                    userLocales,
                );

                const trackingUrl = getBestTranslatedValue(
                    l.translations ?? {},
                    'trackingUrl',
                    l.trackingUrl,
                    linkLocale,
                    userLocales,
                );

                const getUrl = () =>
                    getBestTranslatedValue(
                        l.translations ?? {},
                        'url',
                        l.url,
                        linkLocale,
                        userLocales,
                    );

                const url = isPreview
                    ? getUrl()
                    : trackingUrl
                      ? addSourceTracker(trackingUrl, TrackingSource.Profile)
                      : getUrl();

                return (
                    <SimpleLink
                        key={index}
                        url={url}
                        icon={l.icon}
                        label={label || l.url}
                    />
                );
            })}
        </List>
    );
}
